// extracted by mini-css-extract-plugin
export default {"container":"xA-z","dimension":"yA-z","dimensionLabels":"zA-z"};